import { RDDescription } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { FieldDescription } from './FieldDescription'

export const RDDescriptionFeature: ResourceDetailFeature<RDDescription> = {
  traitId: 'description',
  TaskEditor: FieldDescription,
}
